module.exports = __webpack_public_path__ + "img/footer-usda-organic.5bb35f45.png";